import { useTranslation } from 'react-i18next'
import { Box } from '@/shared/components/box'
import { Typography, Tooltip } from '@material-tailwind/react'
import { colors } from '../utils/colors'
import { useMemo, useRef } from 'react'
import { IoMdHelpCircleOutline } from 'react-icons/io'
import PropTypes from 'prop-types'

export const MonthlyRiskBox = ({ data }) => {
  const monthlyRisk = useMemo(() => {
    const hasTotalRisk = data?.total_risk !== null && data?.total_risk !== undefined && data?.total_risk !== ''
    if (!hasTotalRisk) return null

    if (data.total_risk > 100) return 100

    const totalRisk = Number(data.total_risk)
    if (!Number.isFinite(totalRisk)) return null

    return totalRisk.toFixed(1)
  }, [data])
  const monthlyRiskValue = Number(monthlyRisk)
  const hasMonthlyRiskData = monthlyRisk !== null && monthlyRisk !== '' && Number.isFinite(monthlyRiskValue)

  const { t } = useTranslation()

  const getRiskColor = (value) => {
    if (value === null || value === '' || !Number.isFinite(Number(value))) return 'green'
    if (Number(value) === 100) return 'black'
    if (Number(value) >= 75) return 'red'
    if (Number(value) >= 35) return 'yellow'

    return 'green'
  }
  const tooltipRef = useRef()
  const riskColor = getRiskColor(monthlyRisk)
  const borderColor = colors[riskColor][500]
  const backgroundColor = colors[riskColor][50]

  const changeRiskTitleStyle = (value) => {
    if (value === null || value === '' || !Number.isFinite(Number(value))) return null

    const riskLevels = [
      { threshold: 100, state: 'critic' },
      { threshold: 75, state: 'high' },
      { threshold: 35, state: 'medium' },
      { threshold: 1, state: 'low' },
      { threshold: -Infinity, state: 'null' }
    ]

    const { state } = riskLevels.find(({ threshold }) => value >= threshold)

    return (
      <Typography
        className="font-semibold text-"
        style={{ color: borderColor }}
      >
        {t(`dashboard.bigCard.risk.state.${state}`)}
      </Typography>
    )
  }

  return (
    <Box color={getRiskColor(monthlyRisk)} style={{ backgroundColor, borderColor }} className='flex flex-col justify-between'>
      <div className="flex flex-row gap-3 mb-3">
        <Typography className="text-sm font-semibold">{t('dashboard.bigCard.risk.title')}</Typography>
        <Tooltip
          ref={tooltipRef}
          className="bg-blue-600"
          placement="top-start"
          content={
            <div className="w-80">
              <Typography className="font-medium">{t('dashboard.bigCard.risk.tooltipTitle')}</Typography>
              <Typography
                variant="small"
                color="white"
                className="font-normal opacity-80"
              >
                {t('dashboard.bigCard.risk.tooltipDescription')}
              </Typography>
            </div>
          }
        >
          <div ref={tooltipRef}>
            <IoMdHelpCircleOutline className="text-xl text-gray-400" />
          </div>
        </Tooltip>
      </div>
      <div className='flex justify-between'>
        <Typography className="text-black text-3xl font-semibold">
          {hasMonthlyRiskData ? `${monthlyRisk}%` : 'Sin datos'}
        </Typography>
        {changeRiskTitleStyle(monthlyRisk)}
      </div>
    </Box>
  )
}

MonthlyRiskBox.propTypes = {
  data: PropTypes.shape({
    total_risk: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ])
  })

}

MonthlyRiskBox.defaultProps = {
  data: {}
}
